/* eslint-disable no-unused-vars */
// import { useTheme } from "@emotion/react";
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import Loading from 'assets/images/loading.png';
import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { poppins300 } from 'theme/common.style';
import {
  overlayContainer,
  welcomeBackLoader,
  welcomeLoader,
} from './Loader.style';
import { LoaderContext } from './LoaderContextProvider';

// eslint-disable-next-line no-unused-vars
function Loader({ forced, text }) {
  const theme = useTheme();
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const data1 = localStorage.getItem('userDetail');
  const userDetail = data1 && JSON.parse(data1);
  const isFirstLoginKey = localStorage.getItem('isFirstLogin');
  const { loaderConfig, showUserName } = useContext(LoaderContext);
  // const [showName, setShowName] = useState(false);
  useEffect(() => {
    if (loaderConfig?.isVisible || forced) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [loaderConfig?.isVisible]);

  return loaderConfig?.isVisible || forced ? (
    <Box sx={overlayContainer}>
      {showUserName && (
        <>
          <Typography
            sx={welcomeBackLoader}
            style={{
              fontSize: matches900 && '24px',
              textAlign: matches900 && 'center',
            }}
          >
            {' '}
            {isFirstLoginKey == 0 ? 'Welcome back' : 'Welcome'},{' '}
            {userDetail?.userName} {userDetail?.userSurName}
          </Typography>
          <Typography
            sx={welcomeLoader}
            style={{
              fontSize: matches900 && '24px',
              textAlign: matches900 && 'center',
            }}
          >
            We are preparing your workspace
          </Typography>
        </>
      )}
      {/* <Typography component="div">BS</Typography> */}
      <img
        alt="Logo"
        src={Loading}
        className="loaderImage"
        style={{ width: matches900 && '150px' }}
      />
      <Typography sx={(poppins300, { fontSize: '20px' })}>
        {/* Processing.. */}
      </Typography>
      <Typography
        sx={{ ...poppins300, fontSize: matches900 ? '14px' : '20px' }}
      >
        Almost Done..
      </Typography>
    </Box>
  ) : null;
}

Loader.defaultProps = {
  forced: false,
  text: '',
};
Loader.propTypes = {
  forced: PropTypes.bool,
  text: PropTypes.string,
};

export default Loader;
